var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showSwitchButton)?_c('adm-button',_vm._b({staticClass:"version-switcher",class:{ scroll: this.scroll },attrs:{"id":_vm.id,"size":"medium"},on:{"click":_vm.onClick}},'adm-button',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }